import { msg } from '@lingui/core/macro';

import { ChampionshipStageTab } from 'modules/championship/domain/enums/championship-stage-tab';
import type { MessageDescriptor } from 'shared/i18n';

/**
 * Порядок вкладок этапа в `TabMenu`. `undefined` — «Редактирование»: своего
 * сегмента у неё нет, это корень `/steps/:stageId`.
 */
export const STAGE_TAB_ORDER: (ChampionshipStageTab | undefined)[] = [
  undefined,
  ChampionshipStageTab.TEAMS,
  ChampionshipStageTab.GRID,
  ChampionshipStageTab.MATCHES,
];

/** Индекс динамической вкладки «Матч: A - B» — она появляется только на странице матча. */
export const STAGE_MATCH_TAB_INDEX = STAGE_TAB_ORDER.length;

const STAGE_TAB_LABELS: Record<ChampionshipStageTab | 'info', MessageDescriptor> = {
  info: msg`Редактирование`,
  [ChampionshipStageTab.TEAMS]: msg`Команды`,
  [ChampionshipStageTab.GRID]: msg`Сетка матчей`,
  [ChampionshipStageTab.MATCHES]: msg`Календарь матчей`,
};

/**
 * Подпись подвкладки этапа. Одно место на таб-бар и хлебные крошки — иначе они
 * разъезжаются. Дескриптор: переводит вызывающая сторона (`t(getStageTabLabel(tab))`).
 */
export const getStageTabLabel = (tab: ChampionshipStageTab | undefined): MessageDescriptor => STAGE_TAB_LABELS[tab ?? 'info'];
